// Shared across every page - the 7 authenticated pages (via Shell in
// App.jsx) and the 3 unauthenticated auth pages (Login/ForgotPassword/
// SetNewPassword, which don't go through Shell and so import this
// directly). Kept as one component rather than duplicating the markup in
// 4 places so the copyright year/link only ever needs updating once.
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer text-center text-muted small py-3">
      &copy; {year} Bizmoto. Powered by{' '}
      <a href="https://pepltd.com.au/" target="_blank" rel="noopener noreferrer">
        Peppermint Innovation
      </a>
      .
    </footer>
  );
}
